import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { Dayjs } from 'dayjs';
import styles from './SmartRangePicker.module.scss';

const { RangePicker } = DatePicker;

interface SmartRangePickerProps {
  value?: [Dayjs, Dayjs] | null;
  onChange?: (dates: [Dayjs, Dayjs] | null) => void;
  placeholder?: [string, string];
  format?: string;
  allowClear?: boolean;
  className?: string;
  prefix?: React.ReactNode;
}

const SmartRangePicker: React.FC<SmartRangePickerProps> = ({
  value,
  onChange,
  placeholder = ["", ""],
  format = "DD.MM.YYYY",
  allowClear = true,
  className,
  prefix
}) => {
  const [internalValue, setInternalValue] = useState<[Dayjs, Dayjs] | null>(value || null);

  useEffect(() => {
    setInternalValue(value || null);
  }, [value]);



  const handleCalendarChange = (dates: any, dateStrings: [string, string]) => {
    if (dates && dates[0] && !dates[1]) {
      // Start date seçildiğinde hemen end date'i de aynı tarih yap
      const sameDateRange: [Dayjs, Dayjs] = [dates[0], dates[0]];
      setInternalValue(sameDateRange);
      onChange?.(sameDateRange);
    } else if (!dates) {
      // Clear butonu ile temizlendiğinde
      setInternalValue(null);
      onChange?.(null);
    }
  };

  const handleChange = (dates: any, dateStrings: [string, string]) => {
    if (dates && dates[0] && dates[1]) {
      // Her iki tarih de seçildiyse normal range olarak set et
      setInternalValue(dates);
      onChange?.(dates);
    } else if (!dates) {
      // Clear butonu ile temizlendiğinde
      setInternalValue(null);
      onChange?.(null);
    }
  };

  const handleOpenChange = (open: boolean) => {
    if (!open && internalValue && internalValue[0] && !internalValue[1]) {
      // Calendar kapandığında sadece start date varsa end date'i de aynı tarih yap
      const sameDateRange: [Dayjs, Dayjs] = [internalValue[0], internalValue[0]];
      setInternalValue(sameDateRange);
      onChange?.(sameDateRange);
    }
  };

  return (
    <RangePicker
      className={className}
      value={internalValue}
      onChange={handleChange}
      onCalendarChange={handleCalendarChange}
      onOpenChange={handleOpenChange}
      placeholder={placeholder}
      format={format}
      allowClear={allowClear}
      prefix={prefix}
    />
  );
};

export default SmartRangePicker; 